import * as React from "react";
import styled from "styled-components";
import LeftMenu from "./LeftMenu";
import { CloseOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { Menu, Dropdown,Button } from "antd";

import { usePage } from "@/component/PageControl";

import AboutModal from "./aboutModal";
import ContactModal from "./contact";
import { useAuth } from "@/component/Auth";
import { storage } from "@/util";
import { LOGININFOSTORE, LOGINTOKEN, APKNAME, RECORD_SERVER } from "@/config/const";
import isElectron from "is-electron";
import { Link, useHistory } from "react-router-dom";
import { useRTM } from "@/component/Rtm";

const SmallFrame = styled.div`
  width: 832px;
  height: 562px;
  border-radius: 3px;
  display: flex;
  box-shadow: 2px 2px 4px 2px rgba(0, 0, 0, 0.1);
  .aclose {
    position: absolute;
    right: 5px;
    top: 5px;
    width: 14px;
    height: 14px;
  }
`;

const MainContentDiv = styled.div<{
  pt: string;
  children?: any;
  [k: string]: any;
}>`
  flex: 1;
  display: flex;
  position: relative;
  ${(p) => (p.pt === "setting" ? "position: relative" : "")}
  .abouticon {
    position: absolute;
    right: 10px;
    top: 8px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
  .modal {
    position: absolute;
    right: 0;
    top: 0;
    width: 632px;
    height: 562px;
    background: white;
    z-index: 99;
  }
`;

const MainContent: React.FC<{ children?: any; [k: string]: any }> = (p) => {
  const { isRTMKicked, disconnectRTM, connectRTM } = useRTM();
  const history = useHistory();
  const page = usePage();
  const { pagetype, leaveSetting } = page;
  const auth = useAuth();
  const [showAbout, setShowAbout] = React.useState(false);
  const [showContact, setShowContact] = React.useState(false);
  const { loggedIn } = auth;

  React.useEffect(() => {
    //每次刷新应该会调用这里
    const loginfo = storage.get(LOGININFOSTORE);
      const token = storage.get(LOGINTOKEN);
      if(loginfo.userId && token){
        console.log("[MainContent] loginfo.userId::"+loginfo.userId)
      //如果刷新页面，则重新连接rtm
      const connectRTMAsync = async () => {
        await connectRTM();
      };
      connectRTMAsync();
    }

  }, []);

  React.useEffect(() => {
    if (isRTMKicked) {
      //websocket都被踢了，就不用发logout了 
      //关闭rtm
      disconnectRTM();
      storage.remove(LOGININFOSTORE);
      storage.remove(LOGINTOKEN);
      if (isElectron()) {
        history.replace("/");
      } else {
        alert("检测到相同账号重复登录，已自动退出!");
        window.location.href = "/";
      }
    }
  }, [isRTMKicked]);

  const gotoMyRecords = ()=>{
     
     //
    const accessToken = storage.get(LOGINTOKEN);
    // const w=window.open(loggedIn?RECORD_SERVER:RECORD_SERVER);
    const username = auth.loginfo.username; // 替换为你的用户名
 
    const url = loggedIn ? `${RECORD_SERVER}#/autologin/username=${username}/token=${accessToken}` : RECORD_SERVER;
    console.log("gotoMyRecords url::"+url)
    const w = window.open(url);
  };

  const exitlogin = () => {
    storage.remove(LOGININFOSTORE);
    storage.remove(LOGINTOKEN);
    if (isElectron()) {
      alert(`推出登陆!`);
      history.replace("/");
    } else {
      window.location.href = "/";
    }
  };

  const menu = (
    <Menu>
      {loggedIn && (
        <Menu.Item onClick={gotoMyRecords} key="aaa0">
          <span>我的录制</span>
        </Menu.Item>
      )}
      <Menu.Item onClick={() => setShowAbout(true)} key="aaa1">
        <span>关于我们</span>
      </Menu.Item>
      <Menu.Item onClick={() => setShowContact(true)} key="aaa2">
        <span>联系我们</span>
      </Menu.Item>
      {/* <Menu.Item key="aaa4">
        <span> <a
            href={`http://${window.location.hostname}:8012/latest/${APKNAME}`}
            target="_blank"
            rel="noreferrer"
          >
            安卓下载
          </a></span>
      </Menu.Item> */}
      {loggedIn && (
        <Menu.Item onClick={exitlogin} key="aaa3">
          <span>退出登录</span>
        </Menu.Item>
      )}
    </Menu>
  );

  if (pagetype !== "setting" && pagetype !== "main") return <></>;

  return (
    <MainContentDiv pt={pagetype} className="maincontent">
      
      {p.children}
      {pagetype === "setting" ? (
        <div className="aclose">
          <CloseOutlined onClick={leaveSetting} />
        </div>
      ) : (
        <div className="abouticon">
         
          <Dropdown overlay={menu} placement="bottomRight" arrow>
            <UnorderedListOutlined style={{ fontSize: 20 }} />
          </Dropdown>
        </div>
      )}
      <AboutModal visible={showAbout} afterClose={() => setShowAbout(false)} />
      <ContactModal
        visible={showContact}
        afterClose={() => setShowContact(false)}
      />
    </MainContentDiv>
  );
};

const SmallLayout: React.FC<{ children?: any; [k: string]: any }> = (p) => {
  return (
    <SmallFrame>
      <LeftMenu />
      <MainContent>{p.children}</MainContent>
    </SmallFrame>
  );
};

export default SmallLayout;
